import React from 'react';
import {ContentTemplate, SectionHeader, Typography} from 'web-library';
import {useTranslation} from 'react-i18next';
import RetrievePaymentDetailsForm from './RetrievePaymentDetailsForm';

const SchoolCandidatePayment = () => {
  const {t} = useTranslation();
  return (
      <>
        <ContentTemplate isContinuable>
          <SectionHeader title={t('components->>SchoolCandidatePayment.CandidateDetails')}/>
          <Typography variant="body1">
            {t('components->>SchoolCandidatePayment.CandidateDetailsInstruction')}
          </Typography>
        </ContentTemplate>
        <RetrievePaymentDetailsForm/>
      </>
  );
};

export default SchoolCandidatePayment;
